export const careersIs = {
  hero: {
    title: 'Vertu hluti af liðinu',
    subtitle:
      'Vertu hluti af ástríðufullri fjölskyldu okkar og deildu ástinni á ektri ítalskri matargerð',
  },
  whyJoin: {
    title: 'Af hverju að vinna hjá Rossopomodoro',
    subtitle:
      'Að vinna hjá okkur þýðir að vera hluti af ástríðufullu liði sem helgað er ektri ítalskri matargerð.',
    benefits: [
      {
        title: 'Starfsþróun',
        description:
          'Við fjárfestum í þróun liðsmanna okkar í gegnum þjálfun og framgangsmöguleika.',
      },
      {
        title: 'Liðsmenning',
        description:
          'Upplifðu samvinnuþýtt, stuðningsfullt umhverfi þar sem framlag allra er metið að verðleikum.',
      },
      {
        title: 'Matreiðslufrelsi',
        description: 'Vinndu með úrvals hráefni og lærðu ekta ítalska tækni frá reyndum kokkum.',
      },
      {
        title: 'Fríðindi',
        description: 'Samkeppnishæf laun, starfsmannmatur og tækifæri til faglegrar þróunar.',
      },
    ],
  },
  application: {
    title: 'Sæktu um að ganga til liðs við okkur',
    subtitle:
      'Við erum alltaf að leita að ástríðufullu fólki til að ganga til liðs við fjölskylduna okkar',
    joinFamily: 'Vertu hluti af fjölskyldunni',
    joinFamilyDescription:
      'Við erum meira en samstarfsmenn—við erum fjölskylda sameinuð af ástríðu okkar fyrir ítalskri matargerð.',
    form: {
      firstName: 'Fornafn',
      lastName: 'Eftirnafn',
      email: 'Netfang',
      phone: 'Símanúmer',
      position: 'Staða sem þú hefur áhuga á',
      whyWorkWithUs: 'Af hverju viltu vinna hjá okkur?',
      resume: 'Ferilskrá',
      coverLetter: 'Kynningarbréf',
      gdprConsent:
        'Ég samþykki vinnslu persónuupplýsinga minna í samræmi við persónuverndarstefnu vegna ráðningarferlis',
      submitButton: 'Senda umsókn',
      submitting: 'Sendi...',
      chooseFile: 'Velja skrá',
      resumeHelp: 'Hlaðu upp ferilskránni þinni (PDF, DOC, DOCX - hámark 5MB)',
      coverLetterHelp: 'Hlaðdu upp kynningarbréfinu þínu (PDF, DOC, DOCX - hámark 2MB)',
      note: 'Við munum fara yfir umsóknina þína og hafa samband innan 3-5 virkra daga.',
      successMessage:
        'Umsóknin þín hefur verið send! Við munum fara yfir hana og hafa samband innan 3-5 virkra daga.',
      errorMessage: 'Mistókst að senda umsókn. Vinsamlegast reyndu aftur síðar.',
      placeholders: {
        firstName: 'Fornafnið þitt',
        lastName: 'Eftirnafnið þitt',
        email: 'netfang@example.com',
        phone: '+354 123 4567',
        position: 'Veldu stöðu',
        whyWorkWithUs:
          'Segðu okkur af hverju þú vilt vinna hjá Rossopomodoro og hvað gerir þig að frábæru vali...',
      },
      positions: [
        'Þjónn/Þjónustustúlka',
        'Eldhússtarfsfólk',
        'Pizza kokkur',
        'Aðstoðarkokkur',
        'Stjórnandi',
        'Móttökumaður',
        'Barþjónn',
        'Annað',
      ],
      validation: {
        required: 'Þessi reitur er nauðsynlegur',
        emailFormat: 'Vinsamlegast sláðu inn gilt netfang',
        maxLength: 'Hámark 500 stafir leyfðir',
        fileType: 'Aðeins PDF, DOC og DOCX skrár eru leyfðar',
        fileSize: 'Skráarstærð verður að vera minni en {size}',
        resumeRequired: 'Ferilskrá er nauðsynleg',
        gdprRequired: 'Þú verður að samþykkja vinnslu gagna til að senda umsóknina þína',
      },
    },
  },
};
